{
  "version": "1.0.0",
  "name": "GitGovernance Default Methodology",
  "description": "Standard GitGovernance workflow with quality gates and agent collaboration",
  "state_transitions": {
    "review": {
      "from": [
        "draft"
      ],
      "requires": {
        "command": "gitgov task submit",
        "signatures": {
          "__default__": {
            "role": "submitter",
            "capability_roles": [
              "author"
            ],
            "min_approvals": 1
          }
        }
      }
    },
    "ready": {
      "from": [
        "review"
      ],
      "requires": {
        "command": "gitgov task approve",
        "signatures": {
          "__default__": {
            "role": "approver",
            "capability_roles": [
              "approver:product"
            ],
            "min_approvals": 1
          },
          "design": {
            "role": "approver",
            "capability_roles": [
              "approver:design"
            ],
            "min_approvals": 1
          },
          "quality": {
            "role": "approver",
            "capability_roles": [
              "approver:quality"
            ],
            "min_approvals": 1
          }
        }
      }
    },
    "active": {
      "from": [
        "ready",
        "paused"
      ],
      "requires": {
        "event": "first_execution_record_created",
        "custom_rules": [
          "task_must_have_valid_assignment_for_executor"
        ]
      }
    },
    "done": {
      "from": [
        "active"
      ],
      "requires": {
        "command": "gitgov task complete",
        "signatures": {
          "__default__": {
            "role": "approver",
            "capability_roles": [
              "approver:quality"
            ],
            "min_approvals": 1
          }
        }
      }
    },
    "archived": {
      "from": [
        "done"
      ],
      "requires": {
        "event": "changelog_record_created"
      }
    },
    "paused": {
      "from": [
        "active",
        "review"
      ],
      "requires": {
        "event": "feedback_blocking_created"
      }
    },
    "discarded": {
      "from": [
        "ready",
        "active"
      ],
      "requires": {
        "command": "gitgov task cancel",
        "signatures": {
          "__default__": {
            "role": "canceller",
            "capability_roles": [
              "approver:product",
              "approver:quality"
            ],
            "min_approvals": 1
          }
        }
      }
    }
  },
  "custom_rules": {
    "task_must_have_valid_assignment_for_executor": {
      "description": "Task must have a valid assignment before execution can begin",
      "validation": "assignment_required"
    },
    "task_must_be_in_active_sprint": {
      "description": "Task must belong to an active sprint cycle",
      "validation": "sprint_capacity"
    },
    "epic_promotion_required": {
      "description": "Complex tasks must be promoted to epic with child cycles",
      "validation": "epic_complexity"
    }
  },
  "view_configs": {
    "kanban-4col": {
      "columns": {
        "Draft": [
          "draft"
        ],
        "In Progress": [
          "review",
          "ready",
          "active"
        ],
        "Review": [
          "done"
        ],
        "Done": [
          "archived"
        ],
        "Cancelled": [
          "discarded"
        ]
      },
      "theme": "minimal",
      "layout": "horizontal"
    },
    "kanban-7col": {
      "columns": {
        "Draft": [
          "draft"
        ],
        "Review": [
          "review"
        ],
        "Ready": [
          "ready"
        ],
        "Active": [
          "active"
        ],
        "Done": [
          "done"
        ],
        "Archived": [
          "archived"
        ],
        "Blocked": [
          "paused"
        ],
        "Cancelled": [
          "discarded"
        ]
      },
      "theme": "corporate",
      "layout": "vertical"
    }
  }
}